import { type HansardLine, type HansardSection } from '@prisma/client'
import { Outlet, useLocation } from '@remix-run/react'
import Hansard, {
  HansardProvider,
} from '#app/components/HansardSidebar/Hansard.tsx'
import { TabbedLink, TabbedLinks } from '#app/components/ui/tabbed_links.tsx'
import SectionHeader from './header/SectionHeader'

export default function SectionLayout({
  section,
  lines,
}: {
  section: HansardSection
  lines: HansardLine[]
}) {
  const location = useLocation()
  const links = [
    { to: './summary', label: 'Summary', active: false },
    { to: './statement', label: 'Statement', active: false },
    { to: './speakers', label: 'Speakers', active: false },
    { to: './outline', label: 'Outline', active: false },
  ]
  links.forEach(link => {
    if (location.pathname.endsWith(link.to.slice(2))) {
      link.active = true
    }
  })

  return (
    <HansardProvider lines={lines}>
      <main className="flex h-full">
        <div className="grow overflow-auto">
          <div className="mx-auto flex h-full max-w-screen-lg flex-col px-8">
            <SectionHeader section={section} />

            <TabbedLinks>
              {links.map(({ to, label, active }) => (
                <TabbedLink key={to} to={to} active={active}>
                  {label}
                </TabbedLink>
              ))}
            </TabbedLinks>

            <div className="mb-4 shrink grow overflow-auto">
              <Outlet />
            </div>
          </div>
        </div>
        <div className="w-screen-md self-stretch">
          <Hansard />
        </div>
      </main>
    </HansardProvider>
  )
}
